import React from "react";
import { Box, Card, CardContent, Typography, Divider } from "@mui/material";
import { Phone, Email, ContactSupport } from "@mui/icons-material";

export default function ContactUs() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 3,
        backgroundColor: "#f5f5f5",
      }}
    >
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        sx={{ fontWeight: 600, color: "#333", textAlign: "center", mb: 4 }}
      >
        Contact Us
      </Typography>

      <Card sx={{ maxWidth: 600, width: "100%", boxShadow: 3 }}>
        <CardContent sx={{ padding: 4 }}>
          <Box display="flex" alignItems="center" mb={3}>
            <ContactSupport sx={{ fontSize: 40, color: "#3B76EF", mr: 2 }} />
            <Typography
              variant="h5"
              component="h2"
              sx={{ fontWeight: 500, color: "#333" }}
            >
              Get in Touch
            </Typography>
          </Box>

          <Divider sx={{ mb: 3 }} />

          <Typography
            variant="body1"
            sx={{ mb: 4, lineHeight: 1.8, color: "#666" }}
          >
            For questions or concerns regarding these Terms, please contact us
            using the information below:
          </Typography>

          {/* Phone Contact */}
          <Box
            display="flex"
            alignItems="center"
            mb={3}
            sx={{ padding: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
          >
            <Phone sx={{ fontSize: 24, color: "#3B76EF", mr: 2 }} />
            <Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, color: "#333" }}
              >
                Phone Support
              </Typography>
              <Typography variant="body1" sx={{ color: "#666" }}>
                <a
                  href="tel:+919990503332"
                  style={{ color: "#3B76EF", textDecoration: "none" }}
                >
                  +91 99905033332
                </a>
              </Typography>
            </Box>
          </Box>

          {/* Email Contact */}
          <Box
            display="flex"
            alignItems="center"
            mb={3}
            sx={{ padding: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
          >
            <Email sx={{ fontSize: 24, color: "#3B76EF", mr: 2 }} />
            <Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, color: "#333" }}
              >
                Email Support
              </Typography>
              <Typography variant="body1" sx={{ color: "#666" }}>
                <a
                  href="mailto:care@ziggapp.in"
                  style={{ color: "#3B76EF", textDecoration: "none" }}
                >
                  care@ziggapp.in
                </a>
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Typography
            variant="body2"
            sx={{ color: "#888", fontStyle: "italic", textAlign: "center" }}
          >
            We're here to help! Reach out to us for any questions or support.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
